import * as jsxRuntime from "/srv/gitlab-runner/builds/lya-protect/tutelaire/lya-protect-form-gav/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment